import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MasterDataService } from '../masterdata/masterdata.service';
import { WorkFlow } from '../masterdata/models/workFlow';
import { ErrorHandler } from '../utils/error-handler';
import { MessagesService } from '../messages/messages.service';
import { Run } from '../models/run';
import { MaMachineService } from './ma-machine.service';
import { ArrayProject } from '../masterdata/models/arrayProject';
import { Machine } from '../masterdata/models/machine';
import { ProcessFlow } from '../masterdata/models/processFlow';
import { RunProcessStep, RunStatus } from '../models/run-steps';
import { Step } from '../models/step';
import { ApgDeliveryService } from '../apg-delivery/apg-delivery.service';
import { BoxDeliveryDTO } from '../models/boxDelivery';
import { MaPlatePreparationService } from '../ma-plate-preparation/ma-plate-preparation.service';

@Component({
	selector: 'app-ma-machine',
	templateUrl: './ma-machine.component.html',
	styleUrls: ['./ma-machine.component.css']
})
export class MaMachineComponent implements OnInit {
	errorHandler: ErrorHandler = new ErrorHandler;

	selectedLabId: string;
	puid: string;
	// table properties and values
	blocked = false;
	loading: boolean;
	fromDate: Date = new Date();

	workFlowList = [];
	workFlowData: WorkFlow[] = [];
	workFlowMap: Map<string, WorkFlow> = new Map()
	workFlowNameList: string[] = [];

	runs: Run[] = []
	selectedRun: Run = new Run();
	selectedRunStepsMap: Map<string, Step> = new Map();
	runToSearch: string = "";
	sampleToSearch: string = "";

	projectData: Array<ArrayProject> = [];
	projectsList = [];
	selectedProject: ArrayProject = null;
	sampleTypeList = [];
	selectedSampleType: string = null;
	machineData: Array<Machine> = [];
	machinesList = [];
	selectedMachine: string = null;
	linesList = [
		{ label: "Line_EGL", value: "Line_EGL" },
		{ label: "Line_TSU", value: "Line_TSU" }
	];
	selectedLine = null;

	processFlowData: Array<ProcessFlow>;
	selectedProcessFlows = [];
	sampleTypeProcessFlowList = [];
	selectedWorkFlow: string;
	boxIDSearchValue: string = "";
	sampleTypeProcessFlowNameMap: Map<string, string> = new Map();
	showDuplicatePlateIdDialog: boolean = false;
	duplicatePlateID: string = "";
	newPlateID: string = "";
	disableUpdatePlateIDButton: boolean = true;

	constructor(private masterDataService: MasterDataService, private _messagesService: MessagesService, private deliveryService: ApgDeliveryService, private platePreparationService: MaPlatePreparationService,
		private machineService: MaMachineService, private activatedRoute: ActivatedRoute) { }

	ngOnInit() {
		this.puid = localStorage.getItem("PUID");
		this.selectedLabId = JSON.parse(localStorage.getItem('lab')).lab._id;
		this.getAllActiveWorkFlowList()
		this.fromDate.setDate(new Date().getDate() - 5);
		this.fetchRuns();

		this.masterDataService.getConfigList(this.selectedLabId, "arrayProject", 0, 100, true).subscribe({
			next: results => {
				this.projectData = results.data;
				this.projectData.forEach(project => {
					if (project.lab._id == this.selectedLabId)
						this.projectsList.push({ label: project.projectID, value: project })
				})
			},
			error: error => {
				this.showError(error);
			}
		})

		if (this.projectsList && this.projectsList.length == 1) {
			this.selectedProject = this.projectsList[0].value;
		}

		this.masterDataService.getConfigList(this.selectedLabId, "machine", 0, 100, true).subscribe({
			next: results => {
				this.machineData = results.data;
				this.machineData.filter(x => x.type.reception == true).forEach(machine => {
					this.machinesList.push({ label: machine.name, value: machine.barcode })
				})
			},
			error: error => {
				this.showError(error);
			}
		})

		this.getSampleTypeList();
	}

	onApplyFilter() {
		let queryWorkFlowList = this.workFlowNameList.join(',');
		this.fetchRuns(queryWorkFlowList);
	}

	reloadRuns() {
		this.onApplyFilter();
	}


	resetAllFilter() {
		this.workFlowNameList = [];
		this.fromDate = undefined;
		this.fetchRuns();
	}

	fetchRuns(workFlow?: string) {
		this.loading = true;
		if (workFlow === '') {
			workFlow = undefined;
		}
		this.machineService.fetchRuns(this.selectedLabId, workFlow, this.fromDate).subscribe({
			next: (result) => {
				this.runs = result.data;
				this.loading = false;
			},
			error: (error) => {
				this.loading = false;
				this._messagesService.addErrorMessage({
					severity: 'error', summary: 'Failed to fetch runs',
					detail: 'Some issue in pulling the runs info, please try again'
				})
			}
		})
	}

	getAllActiveWorkFlowList() {
		this.blocked = true;
		this.masterDataService.getAllActiveWorkFlow(this.selectedLabId).subscribe({
			next: results => {
				if (results && results.data) {
					this.workFlowData = results.data;
					this.workFlowMap.clear()
					this.workFlowData.forEach(workflow => {
						this.workFlowList.push({ label: workflow.workFlowName, value: workflow.workFlowName });
						this.workFlowMap.set(workflow.workFlowName, workflow)
					});
					this.blocked = false;
				}
			},
			error: (error: any) => {
				this.blocked = false;
				this.showError(error);
			}
		});
	}

	fetchRun(event) {
		this.searchForRunAction(event.data.runId);
	}

	searchForRunAction(runId: string) {
		this.blocked = true;
		this.machineService.fetchRun(runId, this.selectedLabId).subscribe({
			next: (result) => {
				this.blocked = false;
				this.selectedRun = result.data;
				this.selectedRun.boxes = this.selectedRun.boxes ? this.selectedRun.boxes : [];
				this.prepareProcessStepsMap();
				this.sortPlates();
				this.sampleTypeList = [];
				this.sampleTypeProcessFlowList.map((pf) => {
					this.sampleTypeList.push({ label: pf.value, value: pf.value })
				})
				this.selectedProject = this.projectData.find(project => project.projectID == this.selectedRun.projectId)
			},error:  (error) => {
				this.blocked = false;
				this._messagesService.addErrorMessage({
					severity: 'error', summary: 'Failed to fetch run info',
					detail: error.error
				})
			}
		})
	}

	searchForRun() {
		if (!this.runToSearch || this.runToSearch === '') {
			this._messagesService.addWarningMessage({
				severity: 'warn', summary: 'Please enter a runID',
				detail: 'run ID cannot be empty, please enter something to search'
			})
			return;
		}
		this.searchForRunAction(this.runToSearch);
		this.runToSearch = "";
	}

	searchForSample() {
	}

	removeRunSelection() {
		this.selectedRun = new Run();
		this.selectedRun.boxes = [];
		this.selectedRun.runId = "";
		this.selectedLine = null;
		this.selectedSampleType = null;
		this.selectedMachine = null;
		this.selectedRunStepsMap.clear();
	}

	showError(error: any) {
		let message = this.errorHandler.handleError(error);
		this._messagesService.addErrorMessage(message);
	}

	getSampleTypeList() {
		this.sampleTypeProcessFlowNameMap = new Map();
		this.blocked = true;
		this.masterDataService.getConfigList(this.selectedLabId, "processFlow", 0, 100, true).subscribe({
			next: results => {
				this.blocked = false;
				this.processFlowData = results.data;
				this.processFlowData.forEach(p => {
					if (p.automaticReception)
						this.sampleTypeProcessFlowList.push({ "processFlow": p.processFlowName, "value": p.sampleType });
					this.sampleTypeProcessFlowNameMap.set(p.sampleType, p.processFlowName);
				});
			},
			error: (error: any) => {
				this.blocked = false;
				this.showError(error);
			}
		});
	}

	getSelectedWorkFlowSampleType() {
		this.selectedWorkFlow = this.selectedProject.workflow;
		this.sampleTypeList = [];
		this.selectedSampleType = "";
		let processFlowList = this.workFlowMap.has(this.selectedWorkFlow) ? this.workFlowMap.get(this.selectedWorkFlow).processFlow : [];
		this.sampleTypeProcessFlowList.filter(x => processFlowList.includes(x.processFlow)).map((pf) => {
			this.sampleTypeList.push({ label: pf.value, value: pf.value })
		})
		if (this.sampleTypeList.length == 0) {
			this._messagesService.addErrorMessage({
				severity: 'error', summary: "No sample types found for workflow - " + this.selectedWorkFlow,
				detail: "Please check the MDM configurations and try again."
			})
			return;
		}
		if (this.sampleTypeList && this.sampleTypeList.length == 1) {
			this.selectedSampleType = this.sampleTypeList[0].value;
		}
	}

	checkForMandatoryFieldsForNewRun(): boolean {
		if (!this.selectedProject) {
			this._messagesService.addWarningMessage({
				severity: 'warn', summary: 'Project ID is missing',
				detail: 'Select one of the available projects to proceed further'
			})
			return false
		}
		if (!this.selectedRun.machineId) {
			this._messagesService.addWarningMessage({
				severity: 'warn', summary: 'Machine ID is missing',
				detail: 'Provide a machine id to proceed further'
			})
			return false
		}
		if (!this.selectedRun.line) {
			this._messagesService.addWarningMessage({
				severity: 'warn', summary: 'Missing Line',
				detail: 'Select the line from the given options'
			})
			return false
		}
		if (!this.selectedRun.boxes || this.selectedRun.boxes.length === 0) {
			this._messagesService.addWarningMessage({
				severity: 'warn', summary: 'Missing boxes',
				detail: 'Provide atleast 1 box ID to proceed further'
			})
			return false
		}
		return true
	}

	addRequiredFieldsForNewRun() {
		this.selectedRun.projectId = this.selectedProject.projectID;
		this.selectedRun.workFlow = this.selectedProject.workflow;
		this.selectedRun.proxyWeatherbyAPI = this.workFlowMap.has(this.selectedWorkFlow) ? this.workFlowMap.get(this.selectedWorkFlow).proxyWeatherbyAPI : false;
		this.selectedRun.status = RunStatus.RUN_STARTED;
		let newStep = new Step()
		newStep.step = RunProcessStep.CREATE_RUN;
		newStep.startTimeStamp = new Date();
		newStep.startPUID = this.puid;
		newStep.endPUID = "";
		newStep.endTimeStamp = null;
		this.selectedRun.processSteps = [newStep]
		this.selectedRun.samples = [];
		this.selectedRun.plates = [];
		this.selectedRun.comments = [];
		this.selectedRun.lastModifiedBy = this.puid;
	}

	startRun() {
		if (!this.checkForMandatoryFieldsForNewRun()) {
			return;
		}
		this.addRequiredFieldsForNewRun();
		this.blocked = true;
		this.machineService.createRun(this.selectedRun, this.selectedLabId).subscribe({
			next: result => {
				this.selectedRun = result.data;
				this.prepareProcessStepsMap();
				this._messagesService.addSuccessMessage({
					severity: "success", summary: "Run Started",
					detail: "New Run started with runID " + this.selectedRun.runId
				})
				this.blocked = false;
				this.fetchRuns();
			},
			error: error => {
				this._messagesService.addErrorMessage({
					severity: "error", summary: "Failed to start a new run",
					detail: error.error
				})
				this.blocked = false;
			}
		})
	}

	disableStartRunButton() {
		return (
			!this.selectedProject ||
			!this.selectedRun.sampleType || this.selectedRun.sampleType == "" ||
			!this.selectedRun.machineId || this.selectedRun.machineId == "" ||
			!this.selectedRun.line || this.selectedRun.line == ""
		) || (this.selectedRun.status != null && this.selectedRun.status != "")
	}

	prepareProcessStepsMap() {
		this.selectedRunStepsMap.clear();
		if (!this.selectedRun.processSteps || this.selectedRun.processSteps == null)
			return;
		this.selectedRun.processSteps.forEach(step => {
			this.selectedRunStepsMap.set(step.step, step);
		}
		)
	}

	getProcessStepStartPuid(stepName: string): string {
		var stepsMap = this.selectedRunStepsMap;
		var tempStepName = stepName
		return stepsMap.get(tempStepName).startPUID;
	}

	getProcessStepStartTimestamp(stepName: string): Date {
		var stepsMap = this.selectedRunStepsMap;
		var tempStepName = stepName
		return stepsMap.get(tempStepName).startTimeStamp
	}

	isValidProcessStep(stepName: string): boolean {
		var stepsMap = this.selectedRunStepsMap;
		var tempStepName = stepName
		return (stepsMap.get(tempStepName) != undefined && stepsMap.get(tempStepName) != null);
	}

	disableRunFormFields() {
		return (this.selectedRun.status != null && this.selectedRun.status != "")
	}

	deleteValue(index:number) {
		let boxesLength = this.selectedRun.boxes?.length;
		this.selectedRun.boxes.splice(index, 1);

		if(index == boxesLength-1){
			this.blocked = true;
			this.deliveryService.validateBox(this.selectedRun.boxes[index-1], this.selectedLabId).subscribe({
				next: result => {
					this.blocked = false;
					let boxDetails: BoxDeliveryDTO = result.data;
					this.selectedRun.boxReceptionDate = boxDetails.receptionDate;	
				},
				error: error => {
					this.blocked = false;
					this._messagesService.addErrorMessage({
						severity: 'error', summary: "Box fetch failed!!",
						detail: error.error
					})
				}
			});
		}

		if (this.selectedRun.runId != "") {
			this.updateRun("BoxId removed successfully!")		
		}
	}

	searchForBox() {
		if (!this.selectedProject) {
			this._messagesService.addWarningMessage({
				severity: 'warn', summary: 'Project selection',
				detail: 'Please select a project id to proceed further'
			})
			return
		}
		if ("" == this.boxIDSearchValue.trim()) {
			this._messagesService.addWarningMessage({
				severity: "warn", summary: "Box search failed!",
				detail: "Please a search with a valid boxID!"
			})
			return;
		}

		if (this.selectedRun && this.selectedRun.boxes && this.selectedRun.boxes.includes(this.boxIDSearchValue)) {
			this.blocked = false;
			this._messagesService.addWarningMessage({
				severity: "warn", summary: "Box not added!",
				detail: "Box with boxId - " + this.boxIDSearchValue + " is already added!"
			})
			this.boxIDSearchValue = "";
			return;
		}

		this.blocked = true;
		this.deliveryService.validateBox(this.boxIDSearchValue, this.selectedLabId).subscribe({
			next: result => {
				this.blocked = false;
				let boxDetails: BoxDeliveryDTO = result.data;
				if (!boxDetails) {
					this._messagesService.addWarningMessage({
						severity: "warn", summary: "Box not found!",
						detail: "Box with boxId - " + this.boxIDSearchValue + " not found!"
					})
					this.boxIDSearchValue = "";
					return;
				}

				if (boxDetails.status == "COMPLETED") {
					this._messagesService.addWarningMessage({
						severity: "warn", summary: "Box not eligible!",
						detail: "Box has wrong status - " + boxDetails.status
					})
					this.boxIDSearchValue = "";
					return;
				}

				if (boxDetails.projectId != this.selectedProject.projectID) {
					this._messagesService.addWarningMessage({
						severity: "warn", summary: "Box not eligible!",
						detail: "Box belongs to a different project - " + boxDetails.projectId
					})
					this.boxIDSearchValue = "";
					return;
				}
				if (!this.selectedRun.boxes || this.selectedRun.boxes.length === 0) {
					this.selectedRun.boxes = [boxDetails.boxId]
					this.selectedRun.boxReceptionDate = boxDetails.receptionDate
					this.boxIDSearchValue = ''
					if (this.selectedRun.runId != "") {
						this.updateRun("BoxId added to the run successfully!")
					}
					return
				}
				this.selectedRun.boxReceptionDate = new Date(boxDetails.receptionDate)
				this.selectedRun.boxes.push(boxDetails.boxId)
				this.boxIDSearchValue = '';
				if (this.selectedRun.runId != "") {
					this.updateRun("BoxId added to the run successfully!")
				}
			},
			error: error => {
				this.blocked = false;
				this._messagesService.addErrorMessage({
					severity: 'error', summary: "Box fetch failed!!",
					detail: error.error
				})
			}
		});
	}

	updateRun(successMessage: string = null) {
		this.selectedRun.lastModifiedBy = this.puid;
		this.blocked = true;
		this.machineService.updateRun(this.selectedRun, this.selectedLabId).subscribe({
			next: _result => {
				this._messagesService.addSuccessMessage({
					severity: "success", summary: "Run updated successfully",
					detail: successMessage ? successMessage : "Run updated successfully"
				})
				this.blocked = false;
			},
			error: error => {
				this.blocked = false;
				this._messagesService.addErrorMessage({
					severity: "error", summary: "Update Run Failed!",
					detail: error.error
				})
			}
		})
	}

	onLineSelected(event: any) {
		let selectedLine = event.value
		let eglSampleType = 'EGL', tsuSampleType = 'TSU'
		let selectedSampleType;
		if (selectedLine === 'Line_TSU') {
			selectedSampleType = tsuSampleType;
		}
		else if (selectedLine === 'Line_EGL') {
			selectedSampleType = eglSampleType
		}
		let processFlow = this.processFlowData.find(process => process.automaticReception && process.sampleType.includes(selectedSampleType))
		if (!processFlow) {
			this._messagesService.addErrorMessage({
				severity: 'error', summary: 'No process flow defined!',
				detail: `No process flow defined in the MDM for ${selectedSampleType} Samples.`
			})
			this.selectedRun.line = null
			return
		}
		this.selectedRun.sampleType = selectedSampleType
		this.selectedRun.processFlowName = processFlow.processFlowName
	}

	showNoScanDMSamples() {
		return this.selectedRun.noScanDM ? true : false;
	}

	clearPopUpFields() {
		this.duplicatePlateID = '';
		this.newPlateID = '';
	}

	sortPlates() {
		this.selectedRun.plates.sort((a, b) => {
			const hasA = a.endsWith("_D");
			const hasB = b.endsWith("_D");

			if (hasA && !hasB) {
				return -1;
			} else if (!hasA && hasB) {
				return 1;
			} else {
				return a.localeCompare(b);
			}
		})
	}

	duplicatePlatePopup(plateID: string) {
		this.duplicatePlateID = plateID;
		this.showDuplicatePlateIdDialog = true;
		this.disableUpdatePlateIDButton = true;
	}

	updateNewPlateIDInPlate() {
		this.blocked = true;
		this.platePreparationService.updateNewPlateID(this.selectedLabId, this.duplicatePlateID, this.newPlateID).subscribe({
			next: _result => {
				this.blocked = false;
				this.updateNewPlateIDInRunPlates();
				this._messagesService.addSuccessMessage({
					severity: "success", summary: "Plate updated successfully!!",
					detail: "PlateID updated with " + this.newPlateID
				})
				this.showDuplicatePlateIdDialog = false;
			},error:  error => {
				this.blocked = false;
				this.showDuplicatePlateIdDialog = false;
				this._messagesService.addErrorMessage({
					severity: "error", summary: "Update New PlateID Failed!",
					detail: error.error
				})
			}
		})
	}
	updateNewPlateIDInRunPlates() {
		this.blocked = true;

		let body = {
			"labId": this.selectedLabId,
			"runId": this.selectedRun.runId,
			"duplicatePlateId": this.duplicatePlateID,
			"newPlateId": this.newPlateID
		}

		this.machineService.updateRunNewPlateID(body).subscribe({
			next: result => {
				this.blocked = false;
				this.selectedRun = result.data;
				this.selectedRun.boxes = this.selectedRun.boxes ? this.selectedRun.boxes : [];
				this.sortPlates();
			},error:  error => {
				this.blocked = false;
				this._messagesService.addErrorMessage({
					severity: "error", summary: "Update New PlateID Failed!",
					detail: error.error
				})
			}
		})
	}

	checkNewPlateIDPresent() {
		if (this.newPlateID == "") {
			this._messagesService.addWarningMessage({
				severity: "warn", summary: "New PlateID empty!"
			})
			return;
		}

		this.blocked = true;
		this.platePreparationService.checkDuplicatePlateId(this.selectedLabId, this.newPlateID,"SOURCE").subscribe({
			next: result => {
				this.blocked = false;
				if (result["duplicate"]) {
					this._messagesService.addWarningMessage({
						severity: 'warn', summary: "Plate_ID already exists",
						detail: `${this.newPlateID} already exists. Please scan a new plate-id!`
					})
					this.newPlateID = "";
				}
				else {
					this.disableUpdatePlateIDButton = false;
				}
			},error:  error => {
				this.blocked = false;
				this._messagesService.addErrorMessage({
					severity: "error", summary: "Check Failed!",
					detail: error.error
				})
			}
		})
	}

	disableUpdateButtonOnChange() {
		this.disableUpdatePlateIDButton = true;
	}

	classForDuplicatePlate(plateID: string) {
		return plateID.endsWith('_D') ? "red-text" : "";
	}

	clickPlateID(plateID: string) {
		if (plateID.endsWith('_D')) {
			this.duplicatePlatePopup(plateID);
		}
	}

}  